import React from 'react';

interface OpenClosedToggleProps {
  isOpen: boolean;
  onToggle: (isOpen: boolean) => void;
}

const OpenClosedToggle: React.FC<OpenClosedToggleProps> = ({ isOpen, onToggle }) => {
  return (
    <div className="flex items-center space-x-3">
      <span className={`text-sm font-medium ${isOpen ? 'text-green-700' : 'text-red-700'}`}>
        {isOpen ? 'Open' : 'Closed'}
      </span>

      <button
        type="button"
        onClick={() => onToggle(!isOpen)}
        className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${
          isOpen ? 'bg-green-600' : 'bg-gray-300'
        }`}
      >
        <span className="sr-only">Toggle shop status</span>
        <span
          className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
            isOpen ? 'translate-x-6' : 'translate-x-1'
          }`}
        />
      </button>
    </div>
  );
};

export default OpenClosedToggle;
